import { combineReducers } from 'redux'

import { getGlobalReducers } from '../../../utils/reducers'

import {
  formSlice,
  girderSlice,
  hangerSlice,
  headerSlice,
  jackSlice,
  jobSettingsSlice,
  jobsSlice,
  joistSlice,
  leftHipSlice,
  resultSlice,
  rightHipSlice,
  settingSlice,
  trussSlice,
  uiSlice,
} from './slices'

const inputReducer = combineReducers({
  [hangerSlice.name]: hangerSlice.reducer,
  [jobSettingsSlice.name]: jobSettingsSlice.reducer,
  [settingSlice.name]: settingSlice.reducer,
  [girderSlice.name]: girderSlice.reducer,
  [headerSlice.name]: headerSlice.reducer,
  [jackSlice.name]: jackSlice.reducer,
  [joistSlice.name]: joistSlice.reducer,
  [leftHipSlice.name]: leftHipSlice.reducer,
  [rightHipSlice.name]: rightHipSlice.reducer,
  [trussSlice.name]: trussSlice.reducer,
  [formSlice.name]: formSlice.reducer,
})

const outputReducer = combineReducers({
  [resultSlice.name]: resultSlice.reducer,
  [jobsSlice.name]: jobsSlice.reducer,
})

const calculationReducer = combineReducers({
  input: inputReducer,
  output: outputReducer,
})

const globalReducers = getGlobalReducers()

const rootReducer = combineReducers({
  [uiSlice.name]: uiSlice.reducer,
  calculation: calculationReducer,
  ...globalReducers,
})

export default rootReducer
